(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3267);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



var Error = function(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "message message--error",
        children: error
    });
};
Error.propTypes = {
    error: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (Error);


/***/ }),

/***/ 31:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





var FallbackInput = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        className: "input-group__field",
        type: "tel"
    }));
};
FallbackInput.defaultProps = {
    props: {}
};
FallbackInput.propTypes = {
    props: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (FallbackInput);


/***/ }),

/***/ 7103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./context/AuthContext.js
var AuthContext = __webpack_require__(4642);
// EXTERNAL MODULE: ./helpers/returnToHandler.js
var returnToHandler = __webpack_require__(9885);
// EXTERNAL MODULE: ./helpers/changePathName.js
var changePathName = __webpack_require__(4977);
// EXTERNAL MODULE: ./helpers/closeParentIframeModal.js
var closeParentIframeModal = __webpack_require__(918);
;// CONCATENATED MODULE: ./components/BackBtn.js










var onClick = function(param) {
    var backPath = param.backPath, router = param.router, returnTo = param.returnTo, isIframe = param.isIframe, backTo = param.backTo;
    if (isIframe) {
        (0,closeParentIframeModal/* default */.Z)();
    } else if (backPath) {
        (0,changePathName/* default */.Z)(router, backPath);
    } else {
        (0,returnToHandler/* default */.Z)(backTo || returnTo);
    }
};
var BackBtn = function(param) {
    var backPath = param.backPath;
    var router = (0,next_router.useRouter)();
    var context = (0,react.useContext)(AuthContext/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: "back-btn",
        onClick: function() {
            return onClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, context), {
                backPath: backPath,
                router: router
            }));
        },
        children: "back"
    });
};
BackBtn.propTypes = {
    backPath: (prop_types_default()).string
};
/* harmony default export */ var components_BackBtn = (BackBtn);

;// CONCATENATED MODULE: ./components/Header.js




var Header = function(param) {
    var title = param.title, backPath = param.backPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BackBtn, {
                backPath: backPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header__title",
                children: title
            })
        ]
    });
};
Header.propTypes = {
    title: (prop_types_default()).string.isRequired,
    backPath: (prop_types_default()).string
};
/* harmony default export */ var components_Header = (Header);


/***/ }),

/***/ 6510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8433);
/* harmony import */ var base64url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5772);
/* harmony import */ var base64url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(base64url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(981);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3346);
/* harmony import */ var _getUrlParameter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3551);





var returnToUrlEncoded =  true ? (0,_getUrlParameter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("return_to") : 0;
var returnToUrlDecoded = returnToUrlEncoded ? base64url__WEBPACK_IMPORTED_MODULE_0___default().decode(returnToUrlEncoded) : "";
var returnToUrlIsStagingOrLocalhost = returnToUrlDecoded.match(/(azstaging\.net|azstage\.in|lvh\.me|localhost)/g);
var isRunAtLocalhost =  true ? window.location.origin.match(/(lvh\.me|localhost)/g) : 0;
var isStaging = returnToUrlIsStagingOrLocalhost || isRunAtLocalhost;
var baseURL = _config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].apiBaseUrl */ .Z.apiBaseUrl[isStaging ? "staging" : "production"];
/* harmony default export */ __webpack_exports__["Z"] = (axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].create */ .Z.create({
    baseURL: baseURL,
    headers: {
        "Accept-Language": _utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* ["default"].language */ .Z.language
    }
}));


/***/ }),

/***/ 4977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6042);

var changePathName = function(router, pathname) {
    var locationSearchParams = Object.fromEntries(new URLSearchParams(window.location.search));
    var query = router.query;
    query = Object.keys(query).length ? query : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, query, locationSearchParams);
    router.push({
        pathname: pathname,
        query: query
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (changePathName);


/***/ }),

/***/ 578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3346);

var phoneOperatorValidate = function(phone) {
    var phoneOperatorFormat = _config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].phoneOperatorFormat */ .Z.phoneOperatorFormat;
    var opCode = phone.slice(0, 3);
    return opCode.match(phoneOperatorFormat);
};
/* harmony default export */ __webpack_exports__["Z"] = (phoneOperatorValidate);


/***/ }),

/***/ 3267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(7421);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-text-mask/dist/reactTextMask.js
var reactTextMask = __webpack_require__(1749);
// EXTERNAL MODULE: ./context/AuthContext.js
var AuthContext = __webpack_require__(4642);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(5518);
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(8509);
;// CONCATENATED MODULE: ./helpers/createPhoneMask.js
var createPhoneMask = function() {
    var phoneMask = function() {
        var rawValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        var mask = [
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/
        ];
        var prefix = [
            "(",
            "0"
        ];
        if (rawValue[0] === "0" || rawValue[0] === "(" && rawValue[1] === "0") {
            prefix = [
                "(",
                /\d/
            ];
        }
        mask = prefix.concat(mask);
        return mask;
    };
    phoneMask.instanceOf = "createNumberMask";
    return phoneMask;
};
/* harmony default export */ var helpers_createPhoneMask = (createPhoneMask);

// EXTERNAL MODULE: ./helpers/phoneOperatorValidate.js
var phoneOperatorValidate = __webpack_require__(578);
// EXTERNAL MODULE: ./components/FallbackInput.js
var FallbackInput = __webpack_require__(31);
// EXTERNAL MODULE: ./components/Error.js
var Error = __webpack_require__(5172);
;// CONCATENATED MODULE: ./components/InputGroupPhone.js













var MaskedInput = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 168).then(__webpack_require__.bind(__webpack_require__, 6099));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6099)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FallbackInput/* default */.Z, {
            defaultValue: "(0"
        });
    },
    ssr: false
});
var InputGroupPhone = function(param) {
    var button = param.button;
    var t = (0,es/* useTranslation */.$G)().t;
    var _useContext = (0,react.useContext)(AuthContext/* default */.Z), phone = _useContext.phone, error = _useContext.error, setPhone = _useContext.setPhone, setError = _useContext.setError, wrongOperator = _useContext.wrongOperator, setWrongOperator = _useContext.setWrongOperator, loading = _useContext.loading, authRef = _useContext.authRef;
    var targetElement = authRef && authRef.current;
    var placeholderChar = " ";
    (0,react.useEffect)(function() {
        return function() {
            setWrongOperator(false);
            if (lib/* isIOS */.gn) (0,bodyScrollLock_esm/* clearAllBodyScrollLocks */.tP)();
        };
    }, []);
    var onKeyDown = function(e) {
        var event = e.nativeEvent;
        var key = event.keyCode || event.charCode;
        var isDefaultValue = event.target.value.length === 2;
        if (key === 13) {
            button.current.click();
        }
        if ((key === 8 || key === 46) && isDefaultValue) {
            event.preventDefault();
        }
    };
    var onKeyUp = function(e) {
        var event = e.nativeEvent;
        var key = event.keyCode || event.charCode;
        var isEmptyValue = event.target.value.length === 0;
        if ((key === 8 || key === 46) && isEmptyValue) {
            setPhone("(0");
        }
    };
    var onFocus = function() {
        if (lib/* isIOS */.gn) (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(targetElement);
    };
    var onBlur = function() {
        if (lib/* isIOS */.gn) (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(targetElement);
    };
    var checkOperator = function(purePhone) {
        if (purePhone.length < 3) {
            setError(0);
            if (wrongOperator) setWrongOperator(false);
            return;
        }
        if ((0,phoneOperatorValidate/* default */.Z)(purePhone)) {
            setError(0);
            if (wrongOperator) setWrongOperator(false);
        } else {
            setError(2);
            setWrongOperator(true);
        }
    };
    var onChange = function(e) {
        var targetPhone = e.nativeEvent.target.value;
        var purePhone = targetPhone.replace(/\D+/g, "");
        var purePhoneLength = purePhone.length;
        setPhone(targetPhone);
        checkOperator(purePhone);
        if (purePhoneLength > 3 && purePhoneLength < 10 && !wrongOperator) {
            setError(0);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("input-group", {
            "has-error": wrongOperator
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaskedInput, {
                mask: helpers_createPhoneMask(),
                placeholderChar: placeholderChar,
                onChange: onChange,
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                onFocus: onFocus,
                onBlur: onBlur,
                id: "phone-field",
                type: "tel",
                value: phone,
                disabled: loading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "input-group__placeholder",
                children: t("input_group_phone.placeholder")
            }),
            wrongOperator && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                error: error
            })
        ]
    });
};
InputGroupPhone.propTypes = {
    button: (prop_types_default()).object.isRequired
};
/* harmony default export */ var components_InputGroupPhone = (InputGroupPhone);

// EXTERNAL MODULE: ./components/Header.js + 1 modules
var Header = __webpack_require__(7103);
// EXTERNAL MODULE: ./queries/requestSmsCode.js
var requestSmsCode = __webpack_require__(3628);
;// CONCATENATED MODULE: ./helpers/phoneIsIncomplete.js
var phoneIsIncomplete = function(context) {
    var purePhone = context.purePhone, error = context.error, loading = context.loading;
    return loading || Boolean(error) || purePhone.length < 10;
};
/* harmony default export */ var helpers_phoneIsIncomplete = (phoneIsIncomplete);

;// CONCATENATED MODULE: ./components/Views/LoginByPhonePage.js













var onClick = function(context, router) {
    if (!helpers_phoneIsIncomplete(context)) {
        (0,requestSmsCode/* default */.Z)(context, router);
    }
};
var LoginByPhonePage = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    var buttonRef = (0,react.useRef)(null);
    var context = (0,react.useContext)(AuthContext/* default */.Z);
    var attemptsExhausted = context.attemptsExhausted, error = context.error, setError = context.setError, wrongOperator = context.wrongOperator, loading = context.loading, predefinedPhone = context.predefinedPhone, setPhone = context.setPhone, purePhone = context.purePhone, isRequestSmsCodeSent = context.isRequestSmsCodeSent;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (error && !attemptsExhausted && !wrongOperator) setError(0);
        if (predefinedPhone) {
            var conformedPhoneNumber = (0,reactTextMask.conformToMask)(predefinedPhone, helpers_createPhoneMask(), {
                guide: false
            });
            setPhone(conformedPhoneNumber.conformedValue);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (purePhone.length === 10 && predefinedPhone && !isRequestSmsCodeSent) {
            (0,requestSmsCode/* default */.Z)(context, router);
        }
    }, [
        purePhone
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("login-by-phone", {
            "has-error": error && !wrongOperator
        }, {
            loading: loading
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                title: t("login_by_phone.title")
            }),
            error && !wrongOperator && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error/* default */.Z, {
                error: error
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputGroupPhone, {
                button: buttonRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: classnames_default()("btn", "btn--default", {
                    disabled: helpers_phoneIsIncomplete(context)
                }),
                onClick: function() {
                    return onClick(context, router);
                },
                ref: buttonRef,
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "loader"
                }) : t("login_by_phone.btn_get_sms")
            })
        ]
    });
};
/* harmony default export */ var Views_LoginByPhonePage = (LoginByPhonePage);

;// CONCATENATED MODULE: ./pages/index.js



var LoginByPhone = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Views_LoginByPhonePage, {});
};
/* harmony default export */ var pages = (LoginByPhone);


/***/ }),

/***/ 3628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3346);
/* harmony import */ var _helpers_axiosInstance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6510);
/* harmony import */ var _helpers_changePathName__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4977);



var requestSmsCode = function(context, router) {
    var purePhone = context.purePhone, setError = context.setError, setLoading = context.setLoading, setAttemptsExhausted = context.setAttemptsExhausted, setCodeRequestsLimit = context.setCodeRequestsLimit, setIsRequestSmsCodeSent = context.setIsRequestSmsCodeSent;
    var auth = _config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].queryPathNames.auth */ .Z.queryPathNames.auth;
    setLoading(true);
    _helpers_axiosInstance__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post(auth, {
        phone: purePhone
    }).then(function(response) {
        var pathname = "/phone-confirmation";
        var _response_data = response.data, codeRequestsLeft = _response_data.code_requests_left;
        setError(0);
        setCodeRequestsLimit(codeRequestsLeft < 1);
        return router.pathname !== pathname && (0,_helpers_changePathName__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(router, pathname);
    }).catch(function(errors) {
        var response = errors.response, request = errors.request, errorsMessage = errors.message;
        if (response) {
            var _response_data = response.data, error = _response_data.error, message = _response_data.message;
            var failedAttempts = error === "failed_attempts";
            var codeRequests = error === "code_requests";
            var wrongPhone = error === "phone";
            if (codeRequests || failedAttempts) {
                setError(1, message);
                setAttemptsExhausted(true);
            } else if (wrongPhone) {
                setError(2, message);
            } else {
                setError(4, message);
            }
        } else if (request) {
            setError(5);
        } else {
            console.log("Error", errorsMessage);
        }
    }).finally(function() {
        setLoading(false);
        setIsRequestSmsCodeSent(true);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (requestSmsCode);


/***/ }),

/***/ 1749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(7294)):0}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0,m.isNil)(n)&&!(0,m.isNil)(e.pipe)||!(0,m.isNil)(n)&&(0,m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask()}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g)}for(var M=e.split(s).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1)}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--}else V+=F;continue e}N=!0}b===!1&&(V+=v.substr(A,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s}return{conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s=""},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else{var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0,p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,s){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [290,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);